// available and supported languages can be found here
// https://github.com/porsche-customer/slsystem-ppn-service/blob/master/ppnMarketplaceData/stages/prod.ts
export const allLanguages = [
	"ar", // Arabic
	"az", // Azerbaijani
	"bg", // Bulgarian
	"bs", // Bosnian
	"cs", // Czech
	"da", // Danish
	"de", // German
	"el", // Greek
	"en", // English
	"es", // Spanish
	"et", // Estonian
	"fi", // Finnish
	"fr", // French
	"he", // Hebrew
	"hr", // Croatian
	"hu", // Hungarian
	"hy", // Armenian
	"it", // Italian
	"ja", // Japanese
	"ka", // Georgian
	"ko", // Korean
	"lt", // Lithuanian
	"lv", // Latvian
	"mk", // Macedonian
	"nl", // Dutch
	"no", // Norwegian
	"pl", // Polish
	"pt", // Portuguese
	"ro", // Romanian
	"ru", // Russian
	"sk", // Slovak
	"sl", // Slovenian
	"sr", // Serbian
	"tr", // Turkish
	"uk", // Ukrainian
	"zh", // Chinese
] as const

export type Language = (typeof allLanguages)[number]
